import { render, staticRenderFns } from "./financeiro-tabela-senioridade.vue?vue&type=template&id=635af25c&scoped=true"
import script from "./financeiro-tabela-senioridade.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-senioridade.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-senioridade.vue?vue&type=style&index=0&id=635af25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635af25c",
  null
  
)

export default component.exports